module.exports = __webpack_public_path__ + "static/media/paper.1bf30122.svg";